var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("DiscountDisplayController", [
    "$scope", "$http", "commonService", "cartService", "urlService", "$timeout", "$window",
    function ($scope, $http, commonService, cartService, urlService, $timeout, $window) {
        $scope.noShow = false;

        //#region Discount Display
        $scope.getpotentialDiscountDisplay = function () {
            if (window.__env && window.__env.showDiscountMessageModal != null && window.__env.showDiscountMessageModal == true && !$window.location.href.toLowerCase().includes("cart")) {
                configs = window.__env;
                var displayPotentialDiscounts = commonService.getCookie("dpd");
                if (displayPotentialDiscounts == null || displayPotentialDiscounts == true) {
                    cartService.checkPotentialShippingDiscounts().then(
                        function (response) {
                            if (response != null && response.data.length > 0) {
                                $scope.potentialDiscounts = response.data;
                                document.getElementById("discountSlider").style.display = 'block';
                                document.getElementById("discountSlider").setAttribute('class', 'selected');

                                $timeout(function () { $scope.closeDiscountModal() }, 5000);
                            }
                        })
                }
            }
        }

        $scope.closeDiscountModal = function () {
            if ($scope.noShow) {
                commonService.setCookie("dpd", false, 1);
            }

            document.getElementById("discountSlider").style.display = 'none';
        }

        $scope.getBrandListingPageUrl = function (brand) {
            return "all/catalog/" + brand.toLowerCase().replace(/ /g, "-");
        }

        $scope.getBrandImageUrl = function (brand) {
            return urlService.getBrandImageUrl(brand);
        }

        window.onload = function () {
            $scope.getpotentialDiscountDisplay();
        };
        //#endregion
    }
]);
